<template>
  <div v-if="show" class="update-scrim">
    <div class="update-modal gap-20">
      <h1 class="felix007">גרסה חדשה זמינה</h1>
      <span class="Heebo">יש לרענן את האפליקציה כדי להמשיך לעבוד עם הגרסה העדכנית</span>
      <BaseButton @click="$emit('refresh')" class="confirm-btn">רענון</BaseButton>
    </div>
  </div>
</template>

<script>
// no close button on purpose - a stale build must reload to keep working
import BaseButton from "./BaseButton.vue";
export default {
  components: { BaseButton },
  props: {
    show: { type: Boolean, required: true },
  },
  emits: ["refresh"],
};
</script>

<style lang="scss" scoped>
.update-scrim {
  position: fixed;
  inset: 0;
  z-index: 100000; // above the header (99999)
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}
.update-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 400px;
  background: black;
  border: 1px solid $primaryTextColor;
  border-radius: 40px;
  padding: 30px;
  h1 {
    font-size: $largestTextSize;
    color: white;
    margin: 0px;
  }
  span {
    text-align: center;
    color: #c4c4c4;
  }
  .confirm-btn {
    width: 100%;
  }
}
</style>
